var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrinkicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 23 40",
    className: "fill-current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.2 17.2.7-6.5v-.1c0-2.1-2.3-3.5-5.4-4.2L19 1.2 16.1.3l-1.6 5.6c-.8-.1-1.7-.1-2.6-.1-5.5 0-11 1.5-11 4.8v.1l.7 6.5c0 .2 0 .3.1.4l1.9 18.8h16.8l1.9-18.8c-.1-.1-.1-.2-.1-.4ZM4.3 14.3c2.1.8 4.8 1.2 7.6 1.2 2.7 0 5.5-.4 7.6-1.2l-.3 2.6c-.6.5-3.2 1.3-7.3 1.3s-6.7-.8-7.3-1.3l-.3-2.6Zm15.5-3.7c-.4.4-1.7 1-3.9 1.4l.8-2.7c1.6.5 2.7 1 3.1 1.3Zm-7.9-1.7c.6 0 1.2 0 1.7.1l-1 3.4h-.7c-4.8 0-7.5-1.2-7.9-1.6v-.1c.4-.6 3-1.8 7.9-1.8ZM6.2 33.4l-1.3-13c2.6.8 5.9.9 6.9.9s4.3-.1 7-.9l-1.3 13H6.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkicon);
export default __webpack_public_path__ + "static/media/drink.icon.566f7b9819bbd0e7390b3ba15c3d080b.svg";
export { ForwardRef as ReactComponent };